import React from 'react';
import {Icon, View} from '@lookiero/aurora';
import {Pressable} from 'react-native-gesture-handler';

import {NavLogo} from '@components/atoms/NavLogo';
import {style} from './BurgerBar.style';
import {useApp} from '@app';

export type BurgerBarProps = {
  hideMenu?: boolean;
  hideLogo?: boolean;
  banner?: React.ReactNode;
};

// we use react-native-gesture-handler Pressable as a workaround for this issue
// https://github.com/expo/expo/issues/29489
export const BurgerBar: React.FC<BurgerBarProps> = ({hideMenu = false, hideLogo = false, banner}) => {
  const {togglePanelVisibility} = useApp();

  return (
    <>
      <View style={style.container}>
        {!hideLogo && <NavLogo />}
        {!hideMenu && (
          <Pressable style={style.menu} onPress={() => togglePanelVisibility(true)}>
            <Icon nativeID="menu-button" testID="menu-button" name="menu" />
          </Pressable>
        )}
      </View>
      {banner}
    </>
  );
};
